import React, { useEffect, useState } from "react";
import "./MembersDetails.css";
import "../../../App";
import "../study_member.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCircleArrowLeft,
  faUser,
  faLocationDot,
  faAt,
  faPhone,
  faUserDoctor,
} from "@fortawesome/free-solid-svg-icons";
import InvestAvatar from "../../../assets/invest-avatar.png";
import { FemaleAvatar } from "../../../assets";
import { study_membersService } from "../../../service";

const MembersDetails = ({
  onBack,
  investigatorId,
  studyId,
  type = "investigator",
}) => {
  const [member, setMember] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    const fetchDetails = async () => {
      try {
        setLoading(true);
        setError("");

        let res;

        if (type === "collaborator") {
          // ✔ Collaborator endpoint only needs userId
          res = await study_membersService.getCollaborator(investigatorId);
        } else {
          // ✔ Investigator endpoint needs studyId + userId
          res = await study_membersService.getInvestigator(
            studyId,
            investigatorId
          );
        }

        setMember(res.data);
      } catch (err) {
        console.error("Erreur lors du chargement des détails :", err);
        setError("Impossible de charger les détails du membre.");
      } finally {
        setLoading(false);
      }
    };

    // For collaborator: only investigatorId is required
    // For investigator: both studyId and investigatorId required
    if (investigatorId && (type === "collaborator" || studyId)) {
      fetchDetails();
    }
  }, [studyId, investigatorId, type]);

  if (loading) return <></>;

  if (error)
    return (
      <div className="alert alert-danger mt-4" role="alert">
        {error}
      </div>
    );

  if (!member)
    return (
      <div className="text-center mt-4">
        <p>Aucune information trouvée.</p>
      </div>
    );

  // Choose avatar based on gender
  const avatarSrc =
    member.gender && member.gender.toLowerCase() === "homme"
      ? InvestAvatar
      : FemaleAvatar;

  return (
    <div className="overflow-y-auto px-0" style={{ height: "100%" }}>
      <div className="container-fluid">
        {/* Header */}
        <div className="d-flex align-items-center justify-content-between gap-2">
          <div
            className="d-flex align-items-center back-arrow"
            onClick={onBack}
            style={{ cursor: "pointer" }}
          >
            <FontAwesomeIcon icon={faCircleArrowLeft} />
          </div>
          <div
            className="active-status d-flex justify-content-center"
            style={{
              backgroundColor: member.is_active
                ? "rgba(77, 100, 102, 1)"
                : "rgba(239, 67, 70, 1)",
              display: "inline-block",
              fontWeight: "500",
            }}
          >
            {member.is_active ? "Active" : "Inactive"}
          </div>
        </div>
        <hr className="mt-2" />

        <div className="d-flex gap-3 align-items-center">
          <div>
            <img src={avatarSrc} alt="Avatar" className="investAvatar" />
          </div>

          <div className="flex-grow-1">
            {/* First row */}
            <div className="row mb-2">
              <div className="col-4">
                <div className="member-field py-2 px-4">
                  <span className="member-field-label">Nom et Prénom</span>
                  <div className="d-flex justify-content-between align-items-center">
                    <span style={{ fontWeight: 500, fontSize: "0.9rem" }}>
                      {member.first_name} {member.last_name}
                    </span>
                    <FontAwesomeIcon icon={faUser} />
                  </div>
                </div>
              </div>

              <div className="col-4">
                <div className="member-field py-2 px-4">
                  <span className="member-field-label">Email</span>
                  <div className="d-flex justify-content-between align-items-center">
                    <span style={{ fontWeight: 500, fontSize: "0.9rem" }}>
                      {member.email || "Non spécifié"}
                    </span>
                    <FontAwesomeIcon icon={faAt} />
                  </div>
                </div>
              </div>

              <div className="col-4">
                <div className="member-field py-2 px-4">
                  <span className="member-field-label">
                    Adresse professionnelle
                  </span>
                  <div className="d-flex justify-content-between align-items-center">
                    <span style={{ fontWeight: 500, fontSize: "0.9rem" }}>
                      {member.professional_address || "Non spécifiée"}
                    </span>
                    <FontAwesomeIcon icon={faLocationDot} />
                  </div>
                </div>
              </div>
            </div>

            {/* Second row */}
            <div className="row">
              <div className="col-4">
                <div className="member-field py-2 px-4">
                  <span className="member-field-label">Téléphone</span>
                  <div className="d-flex justify-content-between align-items-center">
                    <span style={{ fontWeight: 500, fontSize: "0.9rem" }}>
                      {member.phone || "Non spécifié"}
                    </span>
                    <FontAwesomeIcon icon={faPhone} />
                  </div>
                </div>
              </div>

              <div className="col-4">
                <div className="member-field py-2 px-4">
                  <span className="member-field-label">Métier</span>
                  <div className="d-flex justify-content-between align-items-center">
                    <span style={{ fontWeight: 500, fontSize: "0.9rem" }}>
                      {member.profession || "Non spécifié"}
                    </span>
                    <FontAwesomeIcon icon={faUserDoctor} />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MembersDetails;
